/**
 * Get current user's email address
 */
export function getCurrentUserEmail(): string {
  return Office.context.mailbox?.userProfile?.emailAddress || "";
}
